export const userCourses = {
  data: {
    courseName: 'For Patients - Colorful Plate & Reinforcing Portion Sizes',
    courseSlug: 'for-patients-colorful-plate-reinforcing-portion-sizes',
    coverImg: 'https://d2r1lfdvt5an2j.cloudfront.net/uploads/446dfac470ed4e68a51245dfadbb934e/original/colorful_plate.jpg',
  },
};
